window.Reverb = window.Reverb || {};

Reverb.DeleteDraft = (function () {
  function init() {
    bindDraftDeletion();
  }

  function bindDraftDeletion() {
    $(document).on('ajax:success', '[data-bind=\'delete-draft\']', removeDraft);
    $(document).on('ajax:error', '[data-bind=\'delete-draft\']', draftDeletionError);
  }

  function removeDraft(e, data) {
    $(`#${data.dom_id}`).fadeOut();
  }

  function draftDeletionError(e, data) {
    const response = $.parseJSON(data.responseText);
    $(`#${response.dom_id}`).prepend(response.error_messages);
  }

  return {
    init,
    draftDeletionError,
  };
}());

$(() => {
  Reverb.DeleteDraft.init();
});
